import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import loadScripts from '../../../dassets/js/custom';
class InvestmentDetails extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            mode_of_communication: this.refs.mode_of_communication.value,
            initial_investment: this.refs.initial_investment.value,
            mode_of_payment: this.refs.mode_of_payment.value,
            investment_objective: this.refs.investment_objective.value
        }

        this.props.saveValues(data)
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Investment Details</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Initial Investment</label>
                                            <Form.Control type="text" className="form-control" ref="initial_investment" placeholder="Initial Investment" defaultValue={this.props.fieldValues.initial_investment} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mode of Payment<span className="text-danger">*</span></label>
                                            <select ref="mode_of_payment" required className="form-control" defaultValue={this.props.fieldValues.mode_of_payment}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Cheque">Cheque</option>
                                                <option value="Bank Transfer">Bank Transfer</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mode of Communication<span className="text-danger">*</span></label>
                                            <select ref="mode_of_communication" required className="form-control" defaultValue={this.props.fieldValues.mode_of_communication}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Email">Email</option>
                                                <option value="Letter">Letter</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Investment Objective<span className="text-danger">*</span></label>
                                            <select ref="investment_objective" required className="form-control" defaultValue={this.props.fieldValues.investment_objective}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Income">Income</option>
                                                <option value="Growth">Growth</option>
                                                <option value="Preservation of Capital">Preservation of Capital</option>
                                            </select>
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InvestmentDetails;